///
/// EarthBrowser
///
/// Created by Matt Giger on 3/30/2024
/// Copyright (c) 2024 Geodata Labs
///

import { type Stovokor } from "@stovokor/Stovokor"

export interface TimerTask {
	id: number
	delay: number
	nextActivation: number
	dead: boolean
	start?(engine: Stovokor): void
	action(time: number): void
}

export class KernelTimerTask implements TimerTask {
	public id: number = 0
	public nextActivation: number = 0
	public dead: boolean = false
	public readonly delay: number
	private readonly frequency: number
	private readonly count: number
	private readonly callback: () => void
	private _actionCount: number = 0

	constructor(delay: number, frequency: number, callback: () => void, count: number = 0) {
		this.callback = callback
		this.delay = delay
		this.frequency = frequency
		this.count = count
	}

	public action(time: number): void {
		this.callback()

		// schedule the next activation
		if(this.frequency > 0) {

			// check if we've reached the action count
			if(this.count > 0 && ++this._actionCount >= this.count) {
				this.dead = true
				return
			}

			this.nextActivation = time + this.frequency
		} else {
			this.dead = true
		}
	}
}
